const primaryColor = '#00b5e4';
const secondaryColor = '#f29f45';

export default {
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,

    appBarBackground: '#ffffff',

    footerBackground: primaryColor,
    footerColor: '#ffffff'
};



// WEBPACK FOOTER //
// ./resources/assets/js/ThemeVars.js